import { render, staticRenderFns } from "./RealNameStep.vue?vue&type=template&id=a95e7182&scoped=true&"
import script from "./RealNameStep.vue?vue&type=script&lang=js&"
export * from "./RealNameStep.vue?vue&type=script&lang=js&"
import style0 from "./RealNameStep.vue?vue&type=style&index=0&id=a95e7182&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a95e7182",
  null
  
)

export default component.exports